import axios from 'axios';  

import { get, post, put } from '../utils/apiUtils';

// No need to use BASE_URL as it's already configured in apiUtils.js
const API_URL = `/api/v1/persistence`;
const API_PIPELINE =`api/v1/bluemormon/pipeline/Pipeline-1767161596197`;



/**
 * Update system settings
 * @param {Object} getWaitingTask - fetch waiting task
 * @returns {Promise<Object>} Promise resolving to waiting task
 */
export const getTemplateCodes = async () => {
  try {
    const response = await get(`${API_URL}/email_template?skip=0&limit=10`);
    return response;
  } catch (error) {
    console.error('Error while fetching the template codes:', error);
    throw error;
  }
};


/** 
@param {String} tableName - Table name
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const getEmailList = async (tableName = 'bmm_sl_email_request', filters = {}, sort={}) => {
  try {
    const response = await post(`${API_URL}/${tableName}/fetch?skip=0&limit=10`, {filter: filters, sort});
    return response;
  } catch (error) {
    console.log("Error while fetching the emails", error)
  }
}


/** 
@param {String} tableName - Table name
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const getEmailDetails = async (tableName = 'claim_email_request_mms', filters = {}, sort={}) => {
  try {
    const response = await post(`${API_URL}/${tableName}/fetch?skip=0&limit=10`, {filter: filters, sort});
    return response;
  } catch (error) {
    console.log("Error while fetching the email details", error)
  }
}

//https://product-dev-bluemormon.metamorphosys.co.in/services/api/v1/bluemormon/pipeline/Pipeline-1767161596197%27
/** 
 * 
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const fetchpipeline = async (data, filters = {}, sort={}) => {
  try {
    const response = await post(`${API_PIPELINE}`, data);
    return response;
  } catch (error) {
    console.log("Error while fetching the email details", error)
  }
}
/*
@returns {Promise<Object>} Promise resolving to waiting task
*/

export const fetchPollingData = async (filter = {}, sort={}) => {
  try {
    const response = await post(`${API_URL}/pipeline_execution/fetch`, {filter});
    return response;
  } catch (error) {
    console.log("Error while fetching the email details", error)
  }
}


